import { createFileRoute } from '@tanstack/react-router';
import { HomebasesClient } from '@/features/fuel/HomebasesClient';

export const Route = createFileRoute('/_shell/fuel/homebases')({
  component: HomebasesClient,
});
